module.exports = __webpack_public_path__ + "assets/d04c32cc0ba9eeaa350ac4cead20fb3c.mp3";